import * as React from "react";
const SvgDot = (props) => /* @__PURE__ */ React.createElement("svg", props, /* @__PURE__ */ React.createElement("circle", {
	cx: 20,
	cy: 20,
	r: 8
}));
export default SvgDot;
